export default "__VITE_ASSET__DTLVVF7$__"